import { BaseNode } from '../BaseNode';
import { Art57NodeUtils } from './Art57NodeUtils';

export class Art57Node extends BaseNode {

  protected getLabelParamFromAllChildren() {
    let param = 0;
    this.children?.forEach((node) => {
      if (node && node.children?.length) {
        param = param + node.children.length;
      }
    });

    return param;
  }

  protected getLabelParamFromChildren() {
    let param = '0';
    if (this.children && this.children.length > 0)
      param = this.children.length.toString();

    return param;
  }

  createChildTemplate(parameters?: any): Art57Node[] | null {
    return null;
  }

  getMessage(): any {
    let message = {};
    let standardterminology = { standardterminology: {} };

    this.children?.forEach((node) => {
      let art57Node = node as Art57Node;
      let art57Message = art57Node.getMessage();

      if (art57Message != null) {
        if (art57Node.isStandardTerminology()) {
          standardterminology.standardterminology = {
            ...standardterminology.standardterminology,
            ...art57Message,
          };
          message = { ...message, ...standardterminology };
        } else if (art57Node.isSubstancesList()) {
          let internationalcodes: any[] = [];
          let internationalParentCodes: any[] = [];
          let developmentsubstancenames: any[] = [];

          if (
            art57Message.approvedsubstances &&
            art57Message.approvedsubstances.approvedsubstance
          ) {
            for (
              let i = 0;
              i < art57Message.approvedsubstances.approvedsubstance.length;
              i++
            ) {
              if (
                art57Message.approvedsubstances.approvedsubstance[i]
                  .internationalcodes
              ) {
                internationalcodes =
                  art57Message.approvedsubstances.approvedsubstance[i]
                    .internationalcodes.internationalcode;
              }
              if (
                art57Message.approvedsubstances.approvedsubstance[i]
                  .internationalparentcodes
              ) {
                internationalParentCodes =
                  art57Message.approvedsubstances.approvedsubstance[i]
                    .internationalparentcodes.internationalcode;
                for (let j = 0; j < internationalParentCodes.length; j++) {
                  internationalcodes.push(internationalParentCodes[j]);
                }
              }

              if (internationalcodes.length > 0) {
                if (
                  !art57Message.approvedsubstances.approvedsubstance[i]
                    .internationalcodes
                ) {
                  art57Message.approvedsubstances.approvedsubstance[
                    i
                  ].internationalcodes = {
                    internationalcodes: {
                      internationalcode: internationalcodes,
                    },
                  };
                }

                art57Message.approvedsubstances.approvedsubstance[
                  i
                ].internationalcodes.internationalcode = internationalcodes;
              }
              internationalcodes = [];
              internationalParentCodes = [];
            }
          }

          if (
            art57Message.developmentsubstances &&
            art57Message.developmentsubstances.developmentsubstance
          ) {
            for (
              let i = 0;
              i <
              art57Message.developmentsubstances.developmentsubstance.length;
              i++
            ) {
              if (
                art57Message.developmentsubstances.developmentsubstance[i]
                  .internationalcodes
              ) {
                internationalcodes =
                  art57Message.developmentsubstances.developmentsubstance[i]
                    .internationalcodes.internationalcode;
              }
              if (
                art57Message.developmentsubstances.developmentsubstance[i]
                  .internationalparentcodes
              ) {
                internationalParentCodes =
                  art57Message.developmentsubstances.developmentsubstance[i]
                    .internationalparentcodes.internationalcode;
                for (let j = 0; j < internationalParentCodes.length; j++) {
                  internationalcodes.push(internationalParentCodes[j]);
                }
              }

              if (internationalcodes.length > 0) {
                if (
                  !art57Message.developmentsubstances.developmentsubstance[i]
                    .internationalcodes
                ) {
                  art57Message.developmentsubstances.developmentsubstance[
                    i
                  ].internationalcodes = {
                    internationalcodes: {
                      internationalcode: internationalcodes,
                    },
                  };
                }

                art57Message.developmentsubstances.developmentsubstance[
                  i
                ].internationalcodes.internationalcode = internationalcodes;
              }

              internationalcodes = [];
              internationalParentCodes = [];
            }

            for (
              let i = 0;
              i <
              art57Message.developmentsubstances.developmentsubstance.length;
              i++
            ) {
              let substancename =
                art57Message.developmentsubstances.developmentsubstance[i]
                  .substancename;
              let preferred =
                art57Message.developmentsubstances.developmentsubstance[i]
                  .preferred;
              let iscode =
                art57Message.developmentsubstances.developmentsubstance[i]
                  .iscode;
              let developmentsubstancename = {
                substancename,
                preferred,
                iscode,
              };

              if (
                art57Message.developmentsubstances.developmentsubstance[i]
                  .developmentsubstancenames
              ) {
                developmentsubstancenames =
                  art57Message.developmentsubstances.developmentsubstance[i]
                    .developmentsubstancenames.developmentsubstancename;
                developmentsubstancenames.push(developmentsubstancename);
                art57Message.developmentsubstances.developmentsubstance[
                  i
                ].developmentsubstancenames.developmentsubstancename =
                  developmentsubstancenames;
              } else {
                developmentsubstancenames.push(developmentsubstancename);
                art57Message.developmentsubstances.developmentsubstance[
                  i
                ].developmentsubstancenames = {
                  developmentsubstancename: developmentsubstancenames,
                };
              }
              developmentsubstancenames = [];
            }
          }
          message = { ...message, ...art57Message };
        } else {
          message = { ...message, ...art57Message };
        }

        message = { ...message, ...art57Message };
      }
    });

    return { ...this.data.model, ...message };
  }

  setMessage(jsonObjectReceived: any) {

    let jsonObject = { ...jsonObjectReceived };

    // Check nodes with localnumber or ev_Code required for XML message
    if (this.constructor.name === '_TreeNodeApprovedSubstance' ||
      // this standard terminology entity is not using localnumber in old Art.57(xevmpd)        this.constructor.name === '_TreeNodeATCCodeType' ||
      this.constructor.name === '_TreeNodeAttachmentType' ||
      this.constructor.name === '_TreeNodeAuthorisedProduct' ||
      this.constructor.name === '_TreeNodeDevelopmentProduct' ||
      this.constructor.name === '_TreeNodeDevelopmentSubstance' ||
      this.constructor.name === '_TreeNodeMasterFileLocation' ||
      this.constructor.name === '_TreeNodeOrganisationType' ||
      this.constructor.name === '_TreeNodePharmaceuticalFormsType' ||
      this.constructor.name === '_TreeNodeRouteOfAdministrationType' ||
      this.constructor.name === '_TreeNodeSourceType'
    ) {
      if (jsonObject.operationtype && jsonObject.operationtype === 1) { // insert operation
        delete jsonObject.ev_Code; // remove in re-insert operation
      } else {
        delete jsonObject.localnumber;
      }
    }

    Art57NodeUtils.generateFormlyModel(this.data.fields, jsonObject, this.data.model, '');

    this.refreshLabel();

  }

  getListItem(): any[] {
    return [];
  }

  validateBusinessRules(): any[] {
    let errors: any = [];
    return errors;
  }

  isStandardTerminology(): boolean {
    return false;
  }

  isSubstancesList(): boolean {
    return false;
  }
}
